// extracted by mini-css-extract-plugin
module.exports = {"Card":"timer_Card___YrAk","Cardtimer":"timer_Cardtimer__1qSRA","items":"timer_items__3WWUu"};